import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  FileText, Plus, Edit, Trash2, Eye, Download,
  Calendar, MapPin, DollarSign, CheckCircle, XCircle,
  Clock, AlertCircle, Car, User, Building, Hotel, Coffee, Briefcase
} from 'lucide-react';
import SidebarCommercial from '../components/SidebarCommercial';
const handleLogout = () => {
  localStorage.removeItem('token');
  window.location.href = '/';
};
const FichesMissionCommercial = () => {
  const [fiches, setFiches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showViewModal, setShowViewModal] = useState(false);
  const [ficheSelectionnee, setFicheSelectionnee] = useState(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [editMode, setEditMode] = useState(false);

  const optionsTransport = [
    'Véhicule personnel',
    'Véhicule de service',
    'Train',
    'Bus',
    'Taxi',
    'Avion'
  ];

  const [form, setForm] = useState({
    natureMission: 'Prospection',
    autreMission: '',
    descriptionMission: '',
    villesDeplacement: [''],
    dateDepart: '',
    dateRetour: '',
    moyensTransport: [],
    autreTransport: '',
    kilometrageEstime: '',
    fraisCarburantEstimes: '',
    fraisMission: {
      repas: { plafond: '', justificatifRequis: true },
      hotel: { plafond: '', justificatifRequis: true },
      transport: { plafond: '', justificatifRequis: true },
      autres: { description: '', plafond: '', justificatifRequis: true }
    },
    avanceSurFrais: { active: false, montant: '' }
  });

  useEffect(() => {
    fetchFiches();
  }, []);

  const fetchFiches = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await axios.get('    https://vmi1977988.contaboserver.net/api2/commercial/fiches-mission', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFiches(res.data.data);
    } catch (err) {
      console.error('Erreur chargement fiches:', err);
      showMessage('Erreur lors du chargement des fiches', 'error');
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => {
      setMessage('');
      setMessageType('');
    }, 4000);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name.includes('.')) {
      const [parent, child, subchild] = name.split('.');
      setForm(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: subchild ? {
            ...prev[parent][child],
            [subchild]: type === 'checkbox' ? checked : value
          } : value
        }
      }));
    } else {
      setForm(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const handleVilleChange = (index, value) => {
    const newVilles = [...form.villesDeplacement];
    newVilles[index] = value;
    setForm({ ...form, villesDeplacement: newVilles });
  };

  const ajouterVille = () => {
    setForm({ ...form, villesDeplacement: [...form.villesDeplacement, ''] });
  };

  const supprimerVille = (index) => {
    const newVilles = form.villesDeplacement.filter((_, i) => i !== index);
    setForm({ ...form, villesDeplacement: newVilles });
  };

  const handleTransportChange = (transport) => {
    const newTransports = form.moyensTransport.includes(transport)
      ? form.moyensTransport.filter(t => t !== transport)
      : [...form.moyensTransport, transport];
    setForm({ ...form, moyensTransport: newTransports });
  };

  const resetForm = () => {
    setForm({
      natureMission: 'Prospection',
      autreMission: '',
      descriptionMission: '',
      villesDeplacement: [''],
      dateDepart: '',
      dateRetour: '',
      moyensTransport: [],
      autreTransport: '',
      kilometrageEstime: '',
      fraisCarburantEstimes: '',
      fraisMission: {
        repas: { plafond: '', justificatifRequis: true },
        hotel: { plafond: '', justificatifRequis: true },
        transport: { plafond: '', justificatifRequis: true },
        autres: { description: '', plafond: '', justificatifRequis: true }
      },
      avanceSurFrais: { active: false, montant: '' }
    });
    setEditMode(false);
    setFicheSelectionnee(null);
  };

  const handleSubmit = async (e, statut = 'Soumis') => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');

      // Calculer le nombre de jours
      let nombreJours = 0;
      if (form.dateDepart && form.dateRetour) {
        const dateD = new Date(form.dateDepart);
        const dateR = new Date(form.dateRetour);
        const diffTime = Math.abs(dateR - dateD);
        nombreJours = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      }

      const payload = {
        ...form,
        statut,
        nombreJours,
        villesDeplacement: form.villesDeplacement.filter(v => v.trim() !== ''),
        moyensTransport: form.autreTransport
          ? [...form.moyensTransport, form.autreTransport]
          : form.moyensTransport,
        avanceSurFrais: {
          active: Boolean(form.avanceSurFrais.active),
          montant: form.avanceSurFrais.active ? Number(form.avanceSurFrais.montant) || 0 : 0
        },
        engagementCollaborateur: {
          date: new Date()
        }
      };

      if (editMode && ficheSelectionnee) {
        await axios.put(
          `     https://vmi1977988.contaboserver.net/api2/commercial/fiches-mission/${ficheSelectionnee._id}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        showMessage('Fiche modifiée avec succès', 'success');
      } else {
        await axios.post(
          '    https://vmi1977988.contaboserver.net/api2/commercial/fiches-mission',
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        showMessage('Fiche créée avec succès', 'success');
      }

      fetchFiches();
      resetForm();
    } catch (err) {
      console.error('Erreur:', err);
      showMessage(err.response?.data?.message || 'Erreur lors de l\'opération', 'error');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette fiche ?')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.delete(`     https://vmi1977988.contaboserver.net/api2/commercial/fiches-mission/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showMessage('Fiche supprimée avec succès', 'success');
      fetchFiches();
      if (ficheSelectionnee?._id === id) {
        resetForm();
      }
    } catch (err) {
      showMessage(err.response?.data?.message || 'Erreur lors de la suppression', 'error');
    }
  };

  const handleEdit = (fiche) => {
    setFicheSelectionnee(fiche);
    setEditMode(true);
    setForm({
      natureMission: fiche.natureMission || 'Prospection',
      autreMission: fiche.autreMission || '',
      descriptionMission: fiche.descriptionMission || '',
      villesDeplacement: fiche.villesDeplacement || [''],
      dateDepart: fiche.dateDepart ? fiche.dateDepart.split('T')[0] : '',
      dateRetour: fiche.dateRetour ? fiche.dateRetour.split('T')[0] : '',
      moyensTransport: fiche.moyensTransport || [],
      autreTransport: '',
      kilometrageEstime: fiche.kilometrageEstime || '',
      fraisCarburantEstimes: fiche.fraisCarburantEstimes || '',
      fraisMission: fiche.fraisMission || {
        repas: { plafond: '', justificatifRequis: true },
        hotel: { plafond: '', justificatifRequis: true },
        transport: { plafond: '', justificatifRequis: true },
        autres: { description: '', plafond: '', justificatifRequis: true }
      },
      avanceSurFrais: fiche.avanceSurFrais || { active: false, montant: '' }
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openViewModal = (fiche) => {
    setFicheSelectionnee(fiche);
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setFicheSelectionnee(null);
  };

  const generatePDF = (fiche) => {
    const printWindow = window.open('', '', 'width=800,height=600');

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Fiche d'Ordre de Mission - ${fiche.natureMission}</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { 
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
            padding: 40px;
            background: white;
            color: #1f2937;
            line-height: 1.6;
          }
          .header {
            text-align: center;
            border-bottom: 3px solid #3b82f6;
            padding-bottom: 20px;
            margin-bottom: 30px;
          }
          .header h1 {
            color: #1f2937;
            font-size: 28px;
            margin-bottom: 10px;
            text-transform: uppercase;
          }
          .header .subtitle {
            color: #6b7280;
            font-size: 14px;
          }
          .statut-badge {
            display: inline-block;
            padding: 8px 20px;
            border-radius: 20px;
            font-weight: 600;
            font-size: 14px;
            margin: 20px 0;
          }
          .statut-approuve { background: #d1fae5; color: #059669; }
          .statut-soumis { background: #dbeafe; color: #3b82f6; }
          .statut-refuse { background: #fee2e2; color: #dc2626; }
          .statut-rembourse { background: #e0e7ff; color: #4f46e5; }
          .statut-brouillon { background: #fef3c7; color: #d97706; }
          .section {
            margin-bottom: 30px;
            page-break-inside: avoid;
          }
          .section-title {
            font-size: 18px;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 15px;
            padding-bottom: 8px;
            border-bottom: 2px solid #e5e7eb;
            text-transform: uppercase;
          }
          .info-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
            margin-bottom: 15px;
          }
          .info-item {
            padding: 12px;
            background: #f9fafb;
            border-radius: 6px;
            border: 1px solid #e5e7eb;
          }
          .info-label {
            font-size: 12px;
            font-weight: 600;
            color: #6b7280;
            margin-bottom: 4px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .info-value {
            font-size: 14px;
            color: #1f2937;
            font-weight: 500;
          }
          .full-width {
            grid-column: 1 / -1;
          }
          .footer {
            margin-top: 40px;
            padding-top: 20px;
            border-top: 2px solid #e5e7eb;
            text-align: center;
            color: #6b7280;
            font-size: 12px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 15px 0;
            border: 1px solid #e5e7eb;
          }
          th, td {
            padding: 12px;
            text-align: left;
            border: 1px solid #e5e7eb;
          }
          th {
            background: #f9fafb;
            font-weight: 600;
            color: #374151;
            font-size: 13px;
          }
          td {
            font-size: 14px;
            color: #1f2937;
          }
          .signature-section {
            margin-top: 40px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 40px;
          }
          .signature-box {
            border-top: 1px solid #1f2937;
            padding-top: 10px;
            text-align: center;
          }
          @media print {
            body { padding: 20px; }
            .no-print { display: none; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>FICHE D'ORDRE DE MISSION</h1>
          <p class="subtitle">Document officiel de déplacement professionnel</p>
          <div class="statut-badge statut-${fiche.statut.toLowerCase().replace('é', 'e')}">
            ${fiche.statut}
          </div>
        </div>

        <div class="section">
          <div class="section-title">INFORMATIONS DU COMMERCIAL</div>
          <div class="info-grid">
            <div class="info-item">
              <div class="info-label">Nom complet</div>
              <div class="info-value">${fiche.nomComplet || 'N/A'}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Fonction</div>
              <div class="info-value">${fiche.fonction || 'N/A'}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Email</div>
              <div class="info-value">${fiche.email || 'N/A'}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Téléphone</div>
              <div class="info-value">${fiche.telephone || 'N/A'}</div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">OBJET DE LA MISSION</div>
          <div class="info-grid">
            <div class="info-item">
              <div class="info-label">Nature de la mission</div>
              <div class="info-value">${fiche.natureMission}</div>
            </div>
            ${fiche.autreMission ? `
            <div class="info-item">
              <div class="info-label">Précision</div>
              <div class="info-value">${fiche.autreMission}</div>
            </div>
            ` : ''}
            <div class="info-item full-width">
              <div class="info-label">Description détaillée</div>
              <div class="info-value">${fiche.descriptionMission}</div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">LIEU ET DUREE DU DEPLACEMENT</div>
          <div class="info-grid">
            <div class="info-item">
              <div class="info-label">Ville(s) de destination</div>
              <div class="info-value">${fiche.villesDeplacement?.join(', ') || 'N/A'}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Durée</div>
              <div class="info-value">${fiche.nombreJours || 0} jours</div>
            </div>
            <div class="info-item">
              <div class="info-label">Date de départ</div>
              <div class="info-value">${new Date(fiche.dateDepart).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Date de retour</div>
              <div class="info-value">${new Date(fiche.dateRetour).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
            </div>
          </div>
        </div>

        ${fiche.moyensTransport?.length > 0 ? `
        <div class="section">
          <div class="section-title">MOYENS DE TRANSPORT</div>
          <table>
            <thead>
              <tr>
                <th>Moyens de transport</th>
                <th>Kilométrage estimé</th>
                <th>Frais carburant</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>${fiche.moyensTransport.join(', ')}</td>
                <td>${fiche.kilometrageEstime || '—'} km</td>
                <td>${fiche.fraisCarburantEstimes || '—'} MAD</td>
              </tr>
            </tbody>
          </table>
        </div>
        ` : ''}

        ${fiche.fraisMission ? `
        <div class="section">
          <div class="section-title">FRAIS DE MISSION AUTORISES</div>
          <table>
            <thead>
              <tr>
                <th>Type de frais</th>
                <th>Plafond autorisé</th>
                <th>Justificatif requis</th>
              </tr>
            </thead>
            <tbody>
              ${fiche.fraisMission.repas?.plafond ? `
              <tr>
                <td>Repas</td>
                <td>${fiche.fraisMission.repas.plafond} MAD/jour</td>
                <td>${fiche.fraisMission.repas.justificatifRequis ? 'Oui' : 'Non'}</td>
              </tr>
              ` : ''}
              ${fiche.fraisMission.hotel?.plafond ? `
              <tr>
                <td>Hébergement</td>
                <td>${fiche.fraisMission.hotel.plafond} MAD/nuit</td>
                <td>${fiche.fraisMission.hotel.justificatifRequis ? 'Oui' : 'Non'}</td>
              </tr>
              ` : ''}
              ${fiche.fraisMission.transport?.plafond ? `
              <tr>
                <td>Transport</td>
                <td>${fiche.fraisMission.transport.plafond} MAD</td>
                <td>${fiche.fraisMission.transport.justificatifRequis ? 'Oui' : 'Non'}</td>
              </tr>
              ` : ''}
              ${fiche.fraisMission.autres?.plafond ? `
              <tr>
                <td>Autres frais ${fiche.fraisMission.autres.description ? `(${fiche.fraisMission.autres.description})` : ''}</td>
                <td>${fiche.fraisMission.autres.plafond} MAD</td>
                <td>${fiche.fraisMission.autres.justificatifRequis ? 'Oui' : 'Non'}</td>
              </tr>
              ` : ''}
            </tbody>
          </table>
        </div>
        ` : ''}

        ${fiche.avanceSurFrais?.active ? `
        <div class="section">
          <div class="section-title">AVANCE SUR FRAIS</div>
          <div class="info-grid">
            <div class="info-item">
              <div class="info-label">Montant de l'avance demandée</div>
              <div class="info-value">${fiche.avanceSurFrais.montant} MAD</div>
            </div>
          </div>
        </div>
        ` : ''}

        ${fiche.validationHierarchique?.decision ? `
        <div class="section">
          <div class="section-title">VALIDATION HIERARCHIQUE</div>
          <div class="info-grid">
            <div class="info-item">
              <div class="info-label">Décision</div>
              <div class="info-value">${fiche.validationHierarchique.decision}</div>
            </div>
            ${fiche.validationHierarchique.admin ? `
            <div class="info-item">
              <div class="info-label">Validé par</div>
              <div class="info-value">${fiche.validationHierarchique.admin.nom || 'N/A'}</div>
            </div>
            ` : ''}
            ${fiche.validationHierarchique.dateValidation ? `
            <div class="info-item">
              <div class="info-label">Date de validation</div>
              <div class="info-value">${new Date(fiche.validationHierarchique.dateValidation).toLocaleDateString('fr-FR')}</div>
            </div>
            ` : ''}
            ${fiche.validationHierarchique.commentaire ? `
            <div class="info-item full-width">
              <div class="info-label">Commentaire</div>
              <div class="info-value">${fiche.validationHierarchique.commentaire}</div>
            </div>
            ` : ''}
          </div>
        </div>
        ` : ''}

        <!-- Section signatures -->
        <div class="section">
          <div class="section-title">SIGNATURES</div>
          <div class="signature-section">
            <div class="signature-box">
              <p><strong>LE COMMERCIAL</strong></p>
              <p style="margin-top: 40px;">${fiche.nomComplet || 'N/A'}</p>
              <p style="font-size: 12px; color: #6b7280;">Nom et signature</p>
            </div>
            <div class="signature-box">
              <p><strong>LE RESPONSABLE HIERARCHIQUE</strong></p>
              <p style="margin-top: 40px;">${fiche.validationHierarchique?.admin?.nom || 'À signer'}</p>
              <p style="font-size: 12px; color: #6b7280;">Nom et signature</p>
            </div>
          </div>
        </div>

        <div class="footer">
          <p>Document généré le ${new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })} à ${new Date().toLocaleTimeString('fr-FR')}</p>
          <p style="margin-top: 10px; font-weight: 600;">Fiche d'Ordre de Mission - Confidentiel</p>
        </div>

        <script>
          window.onload = function() {
            window.print();
            setTimeout(function() {
              window.close();
            }, 100);
          }
        </script>
      </body>
      </html>
    `);

    printWindow.document.close();
  };

  const getStatutBadge = (statut) => {
    const badges = {
      'Brouillon': { color: '#f59e0b', bg: '#fef3c7' },
      'Soumis': { color: '#3b82f6', bg: '#dbeafe' },
      'Approuvé': { color: '#059669', bg: '#d1fae5' },
      'Refusé': { color: '#dc2626', bg: '#fee2e2' },
      'Remboursé': { color: '#4f46e5', bg: '#e0e7ff' }
    };
    const badge = badges[statut] || badges['Brouillon'];

    return (
      <span style={{
        padding: '0.25rem 0.75rem',
        borderRadius: '4px',
        fontSize: '0.75rem',
        fontWeight: '600',
        color: badge.color,
        background: badge.bg,
        border: `1px solid ${badge.color}`,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.25rem'
      }}>
        {statut}
      </span>
    );
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('fr-FR');
  };

  const formatMoney = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount || 0);
  };

  const calculateTotalFrais = (fiche) => {
    let total = 0;
    if (fiche.fraisMission?.repas?.plafond) {
      total += fiche.fraisMission.repas.plafond * (fiche.nombreJours || 0);
    }
    if (fiche.fraisMission?.hotel?.plafond) {
      total += fiche.fraisMission.hotel.plafond * (fiche.nombreJours || 0);
    }
    if (fiche.fraisMission?.transport?.plafond) {
      total += fiche.fraisMission.transport.plafond;
    }
    if (fiche.fraisMission?.autres?.plafond) {
      total += fiche.fraisMission.autres.plafond;
    }
    return total;
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '48px',
            height: '48px',
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p style={{ color: '#64748b' }}>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc'
    }}><SidebarCommercial onLogout={handleLogout} />

      {/* Header */}
      <div style={{
        background: 'white',
        borderBottom: '1px solid #e5e7eb',
        padding: '1rem 2rem',
        marginBottom: '2rem'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '1400px',
          margin: '0 auto'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <FileText size={32} style={{ color: '#3b82f6' }} />
            <div>
              <h1 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1f2937',
                margin: '0'
              }}>
                Mes Fiches d'Ordre de Mission
              </h1>
              <p style={{ color: '#6b7280', fontSize: '0.875rem', margin: '0.25rem 0 0 0' }}>
                Créez et gérez vos demandes de déplacement
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Message */}
      {message && (
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto 1.5rem auto',
          padding: '1rem 1.5rem',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          fontWeight: '500',
          background: messageType === 'success' ? '#d1fae5' : '#fee2e2',
          color: messageType === 'success' ? '#065f46' : '#991b1b',
          border: `1px solid ${messageType === 'success' ? '#6ee7b7' : '#fca5a5'}`
        }}>
          {messageType === 'success' ? <CheckCircle size={20} /> : <AlertCircle size={20} />}
          {message}
        </div>
      )}

      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        {/* Formulaire */}
        <div style={{
          background: 'white',
          borderRadius: '8px',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '1.5rem'
          }}>
            <h2 style={{
              fontSize: '1.25rem',
              fontWeight: '600',
              color: '#1f2937',
              margin: '0'
            }}>
              {editMode ? 'Modifier la fiche' : 'Nouvelle fiche'}
            </h2>
            {editMode && (
              <button
                onClick={resetForm}
                style={{
                  background: '#f3f4f6',
                  color: '#374151',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  padding: '0.5rem 1rem',
                  cursor: 'pointer',
                  fontSize: '0.875rem'
                }}
              >
                Annuler la modification
              </button>
            )}
          </div>

          <form onSubmit={(e) => handleSubmit(e, 'Soumis')}>
            {/* Section 1: Objet de la mission */}
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                margin: '0 0 1rem 0',
                paddingBottom: '0.5rem',
                borderBottom: '2px solid #3b82f6'
              }}>
                1. Objet de la mission
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '1rem',
                marginBottom: '1rem'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Nature de la mission *
                  </label>
                  <select
                    name="natureMission"
                    value={form.natureMission}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  >
                    <option value="Prospection">Prospection</option>
                    <option value="Suivi clients">Suivi clients</option>
                    <option value="Visite établissements / partenaires">Visite établissements / partenaires</option>
                    <option value="Salon / Événement">Salon / Événement</option>
                    <option value="Autre">Autre</option>
                  </select>
                </div>

                {form.natureMission === 'Autre' && (
                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      color: '#374151',
                      marginBottom: '0.5rem'
                    }}>
                      Précisez *
                    </label>
                    <input
                      type="text"
                      name="autreMission"
                      value={form.autreMission}
                      onChange={handleChange}
                      required={form.natureMission === 'Autre'}
                      placeholder="Autre mission..."
                      style={{
                        width: '100%',
                        padding: '0.5rem',
                        borderRadius: '4px',
                        border: '1px solid #d1d5db',
                        fontSize: '0.875rem'
                      }}
                    />
                  </div>
                )}
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '0.5rem'
                }}>
                  Description détaillée *
                </label>
                <textarea
                  name="descriptionMission"
                  value={form.descriptionMission}
                  onChange={handleChange}
                  required
                  rows="4"
                  placeholder="Décrivez l'objectif et les activités prévues..."
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    borderRadius: '4px',
                    border: '1px solid #d1d5db',
                    fontSize: '0.875rem',
                    fontFamily: 'inherit'
                  }}
                />
              </div>
            </div>

            {/* Section 2: Lieu et durée */}
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                margin: '0 0 1rem 0',
                paddingBottom: '0.5rem',
                borderBottom: '2px solid #3b82f6'
              }}>
                2. Lieu et durée
              </h3>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '0.5rem'
                }}>
                  Ville(s) de déplacement *
                </label>
                {form.villesDeplacement.map((ville, index) => (
                  <div key={index} style={{
                    display: 'flex',
                    gap: '0.5rem',
                    marginBottom: '0.5rem'
                  }}>
                    <input
                      type="text"
                      value={ville}
                      onChange={(e) => handleVilleChange(index, e.target.value)}
                      placeholder="Ville"
                      required
                      style={{
                        flex: 1,
                        padding: '0.5rem',
                        borderRadius: '4px',
                        border: '1px solid #d1d5db',
                        fontSize: '0.875rem'
                      }}
                    />
                    {form.villesDeplacement.length > 1 && (
                      <button
                        type="button"
                        onClick={() => supprimerVille(index)}
                        style={{
                          background: '#fee2e2',
                          color: '#dc2626',
                          border: '1px solid #fca5a5',
                          borderRadius: '4px',
                          padding: '0.5rem',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <Trash2 size={16} />
                      </button>
                    )}
                  </div>
                ))}
                <button
                  type="button"
                  onClick={ajouterVille}
                  style={{
                    background: 'transparent',
                    color: '#3b82f6',
                    border: '1px solid #3b82f6',
                    borderRadius: '4px',
                    padding: '0.5rem 1rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.25rem',
                    fontSize: '0.875rem'
                  }}
                >
                  <Plus size={16} />
                  Ajouter une ville
                </button>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '1rem'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Date de départ *
                  </label>
                  <input
                    type="date"
                    name="dateDepart"
                    value={form.dateDepart}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Date de retour *
                  </label>
                  <input
                    type="date"
                    name="dateRetour"
                    value={form.dateRetour}
                    onChange={handleChange}
                    required
                    min={form.dateDepart}
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Section 3: Moyens de transport */}
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                margin: '0 0 1rem 0',
                paddingBottom: '0.5rem',
                borderBottom: '2px solid #3b82f6'
              }}>
                3. Moyens de transport
              </h3>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '0.5rem'
                }}>
                  Sélectionnez les moyens de transport
                </label>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '0.5rem'
                }}>
                  {optionsTransport.map((transport) => (
                    <label key={transport} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      fontSize: '0.875rem',
                      cursor: 'pointer'
                    }}>
                      <input
                        type="checkbox"
                        checked={form.moyensTransport.includes(transport)}
                        onChange={() => handleTransportChange(transport)}
                        style={{
                          width: '1rem',
                          height: '1rem'
                        }}
                      />
                      {transport}
                    </label>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '0.5rem'
                }}>
                  Autre moyen de transport
                </label>
                <input
                  type="text"
                  name="autreTransport"
                  value={form.autreTransport}
                  onChange={handleChange}
                  placeholder="Autre..."
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    borderRadius: '4px',
                    border: '1px solid #d1d5db',
                    fontSize: '0.875rem'
                  }}
                />
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '1rem'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Kilométrage estimé (km)
                  </label>
                  <input
                    type="number"
                    name="kilometrageEstime"
                    value={form.kilometrageEstime}
                    onChange={handleChange}
                    placeholder="0"
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Frais carburant estimés (MAD)
                  </label>
                  <input
                    type="number"
                    name="fraisCarburantEstimes"
                    value={form.fraisCarburantEstimes}
                    onChange={handleChange}
                    placeholder="0"
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Section 4: Frais de mission */}
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                margin: '0 0 1rem 0',
                paddingBottom: '0.5rem',
                borderBottom: '2px solid #3b82f6'
              }}>
                4. Frais de mission autorisés
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '1rem',
                marginBottom: '1rem'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Plafond repas (MAD/jour)
                  </label>
                  <input
                    type="number"
                    name="fraisMission.repas.plafond"
                    value={form.fraisMission.repas.plafond}
                    onChange={handleChange}
                    placeholder="0"
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Plafond hôtel (MAD/nuit)
                  </label>
                  <input
                    type="number"
                    name="fraisMission.hotel.plafond"
                    value={form.fraisMission.hotel.plafond}
                    onChange={handleChange}
                    placeholder="0"
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  />
                </div>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '1rem',
                marginBottom: '1rem'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Plafond transport (MAD)
                  </label>
                  <input
                    type="number"
                    name="fraisMission.transport.plafond"
                    value={form.fraisMission.transport.plafond}
                    onChange={handleChange}
                    placeholder="0"
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Autres frais (MAD)
                  </label>
                  <input
                    type="number"
                    name="fraisMission.autres.plafond"
                    value={form.fraisMission.autres.plafond}
                    onChange={handleChange}
                    placeholder="0"
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  />
                </div>
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: '#374151',
                  marginBottom: '0.5rem'
                }}>
                  Description autres frais
                </label>
                <input
                  type="text"
                  name="fraisMission.autres.description"
                  value={form.fraisMission.autres.description}
                  onChange={handleChange}
                  placeholder="Précisez..."
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    borderRadius: '4px',
                    border: '1px solid #d1d5db',
                    fontSize: '0.875rem'
                  }}
                />
              </div>
            </div>

            {/* Section 5: Avance sur frais */}
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                margin: '0 0 1rem 0',
                paddingBottom: '0.5rem',
                borderBottom: '2px solid #3b82f6'
              }}>
                5. Avance sur frais
              </h3>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  fontSize: '0.875rem',
                  cursor: 'pointer'
                }}>
                  <input
                    type="checkbox"
                    name="avanceSurFrais.active"
                    checked={form.avanceSurFrais.active}
                    onChange={handleChange}
                    style={{
                      width: '1rem',
                      height: '1rem'
                    }}
                  />
                  Demander une avance sur frais
                </label>
              </div>

              {form.avanceSurFrais.active && (
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Montant de l'avance (MAD) *
                  </label>
                  <input
                    type="number"
                    name="avanceSurFrais.montant"
                    value={form.avanceSurFrais.montant}
                    onChange={handleChange}
                    required={form.avanceSurFrais.active}
                    placeholder="0"
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem'
                    }}
                  />
                </div>
              )}
            </div>

            {/* Actions */}
            <div style={{
              display: 'flex',
              gap: '1rem',
              paddingTop: '1rem',
              borderTop: '1px solid #e5e7eb'
            }}>
              <button
                type="button"
                onClick={(e) => handleSubmit(e, 'Brouillon')}
                style={{
                  background: 'transparent',
                  color: '#3b82f6',
                  border: '1px solid #3b82f6',
                  borderRadius: '4px',
                  padding: '0.75rem 1.5rem',
                  cursor: 'pointer',
                  fontSize: '0.875rem',
                  fontWeight: '600'
                }}
              >
                Enregistrer en brouillon
              </button>
              <button
                type="submit"
                style={{
                  background: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '0.75rem 1.5rem',
                  cursor: 'pointer',
                  fontSize: '0.875rem',
                  fontWeight: '600'
                }}
              >
                {editMode ? 'Mettre à jour' : 'Soumettre la fiche'}
              </button>
            </div>
          </form>
        </div>

        {/* Liste des fiches */}
        <div>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#1f2937',
            margin: '0 0 1rem 0'
          }}>
            Mes fiches créées
          </h2>

          {fiches.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '3rem 2rem',
              background: 'white',
              borderRadius: '8px',
              border: '1px solid #e5e7eb'
            }}>
              <FileText size={64} style={{ color: '#d1d5db', margin: '0 auto 1rem' }} />
              <h3 style={{ color: '#374151', marginBottom: '0.5rem' }}>
                Aucune fiche créée
              </h3>
              <p style={{ color: '#6b7280' }}>
                Vos fiches apparaîtront ici après création
              </p>
            </div>
          ) : (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
              gap: '1rem'
            }}>
              {fiches.map((fiche) => (
                <div key={fiche._id} style={{
                  background: 'white',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  padding: '1.5rem'
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '1rem'
                  }}>
                    <div>
                      <h3 style={{
                        fontSize: '1rem',
                        fontWeight: '600',
                        color: '#1f2937',
                        margin: '0 0 0.5rem 0'
                      }}>
                        {fiche.natureMission}
                      </h3>
                      {getStatutBadge(fiche.statut)}
                    </div>
                    <div style={{ display: 'flex', gap: '0.25rem' }}>
                      <button
                        onClick={() => openViewModal(fiche)}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          color: '#6b7280',
                          cursor: 'pointer',
                          padding: '0.25rem',
                          borderRadius: '4px'
                        }}
                        title="Voir détails"
                      >
                        <Eye size={18} />
                      </button>
                      {(fiche.statut === 'Brouillon' || fiche.statut === 'Refusé') && (
                        <>
                          <button
                            onClick={() => handleEdit(fiche)}
                            style={{
                              background: 'transparent',
                              border: 'none',
                              color: '#3b82f6',
                              cursor: 'pointer',
                              padding: '0.25rem',
                              borderRadius: '4px'
                            }}
                            title="Modifier"
                          >
                            <Edit size={18} />
                          </button>
                          {fiche.statut === 'Brouillon' && (
                            <button
                              onClick={() => handleDelete(fiche._id)}
                              style={{
                                background: 'transparent',
                                border: 'none',
                                color: '#dc2626',
                                cursor: 'pointer',
                                padding: '0.25rem',
                                borderRadius: '4px'
                              }}
                              title="Supprimer"
                            >
                              <Trash2 size={18} />
                            </button>
                          )}
                        </>
                      )}
                      <button
                        onClick={() => generatePDF(fiche)}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          color: '#059669',
                          cursor: 'pointer',
                          padding: '0.25rem',
                          borderRadius: '4px'
                        }}
                        title="Télécharger PDF"
                      >
                        <Download size={18} />
                      </button>
                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                    marginBottom: '1rem'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <MapPin size={14} style={{ color: '#6b7280' }} />
                      <span style={{ fontSize: '0.875rem', color: '#4b5563' }}>
                        {fiche.villesDeplacement?.join(', ') || 'N/A'}
                      </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <Calendar size={14} style={{ color: '#6b7280' }} />
                      <span style={{ fontSize: '0.875rem', color: '#4b5563' }}>
                        {formatDate(fiche.dateDepart)} → {formatDate(fiche.dateRetour)}
                        {fiche.nombreJours && ` (${fiche.nombreJours} jours)`}
                      </span>
                    </div>
                    {fiche.moyensTransport?.length > 0 && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <Car size={14} style={{ color: '#6b7280' }} />
                        <span style={{ fontSize: '0.875rem', color: '#4b5563' }}>
                          {fiche.moyensTransport.join(', ')}
                        </span>
                      </div>
                    )}
                  </div>

                  {fiche.validationHierarchique?.decision === 'Refusé' && fiche.validationHierarchique?.commentaire && (
                    <div style={{
                      background: '#fef2f2',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      border: '1px solid #fecaca',
                      marginBottom: '1rem',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '0.5rem'
                    }}>
                      <AlertCircle size={14} style={{ color: '#dc2626', flexShrink: 0, marginTop: '0.125rem' }} />
                      <span style={{ fontSize: '0.75rem', color: '#991b1b' }}>
                        {fiche.validationHierarchique.commentaire}
                      </span>
                    </div>
                  )}

                  <div style={{
                    fontSize: '0.75rem',
                    color: '#6b7280',
                    borderTop: '1px solid #e5e7eb',
                    paddingTop: '0.75rem'
                  }}>
                    Créé le {formatDate(fiche.createdAt)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Modal Visualisation */}
      {showViewModal && ficheSelectionnee && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '1rem',
          overflow: 'auto'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '8px',
            width: '100%',
            maxWidth: '800px',
            maxHeight: '90vh',
            overflow: 'auto',
            position: 'relative'
          }}>
            {/* Header de la modal */}
            <div style={{
              padding: '1.5rem',
              borderBottom: '1px solid #e5e7eb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              background: 'white',
              zIndex: 10
            }}>
              <div>
                <h3 style={{
                  margin: 0,
                  fontSize: '1.25rem',
                  fontWeight: '600',
                  color: '#1f2937',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  <FileText size={20} />
                  Détails de la fiche de mission
                </h3>
                <p style={{ color: '#6b7280', margin: '0.25rem 0 0 0', fontSize: '0.875rem' }}>
                  Référence: {ficheSelectionnee.reference || 'N/A'}
                </p>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button
                  onClick={() => generatePDF(ficheSelectionnee)}
                  style={{
                    background: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '0.5rem 1rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.25rem',
                    fontSize: '0.875rem'
                  }}
                >
                  <Download size={16} />
                  Télécharger PDF
                </button>
                <button
                  onClick={closeViewModal}
                  style={{
                    background: 'transparent',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    padding: '0.5rem',
                    cursor: 'pointer'
                  }}
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Contenu de la modal */}
            <div style={{ padding: '1.5rem' }}>
              {/* Section Statut et Dates */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1.5rem',
                paddingBottom: '1rem',
                borderBottom: '1px solid #e5e7eb'
              }}>
                <div>
                  {getStatutBadge(ficheSelectionnee.statut)}
                  {ficheSelectionnee.validationHierarchique?.dateValidation && (
                    <p style={{ color: '#6b7280', fontSize: '0.75rem', marginTop: '0.25rem' }}>
                      Validé le: {formatDate(ficheSelectionnee.validationHierarchique.dateValidation)}
                    </p>
                  )}
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ fontSize: '0.875rem', color: '#374151', margin: 0 }}>
                    <strong>Date de création:</strong> {formatDate(ficheSelectionnee.dateCreation || ficheSelectionnee.createdAt)}
                  </p>
                  <p style={{ fontSize: '0.875rem', color: '#374151', margin: '0.25rem 0 0 0' }}>
                    <strong>Départ:</strong> {formatDate(ficheSelectionnee.dateDepart)}
                    {' → '}
                    <strong>Retour:</strong> {formatDate(ficheSelectionnee.dateRetour)}
                  </p>
                </div>
              </div>

              {/* Informations Commercial */}
              <div style={{ marginBottom: '1.5rem' }}>
                <h4 style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#374151',
                  margin: '0 0 0.75rem 0',
                  paddingBottom: '0.5rem',
                  borderBottom: '2px solid #3b82f6',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  <User size={16} />
                  Informations du Commercial
                </h4>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '1rem'
                }}>
                  <div>
                    <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Nom complet</p>
                    <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                      {ficheSelectionnee.nomComplet || ficheSelectionnee.commercial?.nom || 'N/A'}
                    </p>
                  </div>
                  <div>
                    <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Fonction</p>
                    <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                      {ficheSelectionnee.fonction || 'N/A'}
                    </p>
                  </div>
                  <div>
                    <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Email</p>
                    <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                      {ficheSelectionnee.email || ficheSelectionnee.commercial?.email || 'N/A'}
                    </p>
                  </div>
                  <div>
                    <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Téléphone</p>
                    <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                      {ficheSelectionnee.telephone || 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              {/* Détails Mission */}
              <div style={{ marginBottom: '1.5rem' }}>
                <h4 style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#374151',
                  margin: '0 0 0.75rem 0',
                  paddingBottom: '0.5rem',
                  borderBottom: '2px solid #3b82f6',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  <Briefcase size={16} />
                  Détails de la Mission
                </h4>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '1rem',
                  marginBottom: '1rem'
                }}>
                  <div>
                    <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Nature de la mission</p>
                    <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                      {ficheSelectionnee.natureMission}
                    </p>
                  </div>
                  {ficheSelectionnee.autreMission && (
                    <div>
                      <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Autre précision</p>
                      <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                        {ficheSelectionnee.autreMission}
                      </p>
                    </div>
                  )}
                  <div>
                    <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Durée</p>
                    <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                      {ficheSelectionnee.nombreJours || 0} jours
                    </p>
                  </div>
                </div>

                <div>
                  <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Description</p>
                  <div style={{
                    fontSize: '0.875rem',
                    color: '#1f2937',
                    margin: '0.25rem 0',
                    background: '#f9fafb',
                    padding: '0.75rem',
                    borderRadius: '4px',
                    border: '1px solid #e5e7eb',
                    minHeight: '60px'
                  }}>
                    {ficheSelectionnee.descriptionMission || 'Aucune description'}
                  </div>
                </div>
              </div>

              {/* Villes de déplacement */}
              {ficheSelectionnee.villesDeplacement?.length > 0 && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <h4 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#374151',
                    margin: '0 0 0.75rem 0',
                    paddingBottom: '0.5rem',
                    borderBottom: '2px solid #3b82f6',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <MapPin size={16} />
                    Villes de Déplacement
                  </h4>
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.5rem'
                  }}>
                    {ficheSelectionnee.villesDeplacement.map((ville, index) => (
                      <span key={index} style={{
                        background: '#dbeafe',
                        color: '#1e40af',
                        padding: '0.25rem 0.75rem',
                        borderRadius: '4px',
                        fontSize: '0.75rem',
                        border: '1px solid #93c5fd'
                      }}>
                        {ville}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Moyens de transport */}
              {ficheSelectionnee.moyensTransport?.length > 0 && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <h4 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#374151',
                    margin: '0 0 0.75rem 0',
                    paddingBottom: '0.5rem',
                    borderBottom: '2px solid #3b82f6',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <Car size={16} />
                    Moyens de Transport
                  </h4>
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.5rem'
                  }}>
                    {ficheSelectionnee.moyensTransport.map((transport, index) => (
                      <span key={index} style={{
                        background: '#f0f9ff',
                        color: '#0369a1',
                        padding: '0.25rem 0.75rem',
                        borderRadius: '4px',
                        fontSize: '0.75rem',
                        border: '1px solid #bae6fd'
                      }}>
                        {transport}
                      </span>
                    ))}
                  </div>
                  {(ficheSelectionnee.kilometrageEstime || ficheSelectionnee.fraisCarburantEstimes) && (
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                      gap: '1rem',
                      marginTop: '0.75rem'
                    }}>
                      {ficheSelectionnee.kilometrageEstime && (
                        <div>
                          <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Kilométrage estimé</p>
                          <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                            {ficheSelectionnee.kilometrageEstime} km
                          </p>
                        </div>
                      )}
                      {ficheSelectionnee.fraisCarburantEstimes && (
                        <div>
                          <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Frais carburant</p>
                          <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                            {formatMoney(ficheSelectionnee.fraisCarburantEstimes)} MAD
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Frais de mission */}
              {ficheSelectionnee.fraisMission && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <h4 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#374151',
                    margin: '0 0 0.75rem 0',
                    paddingBottom: '0.5rem',
                    borderBottom: '2px solid #3b82f6'
                  }}>
                    Frais de Mission Autorisés
                  </h4>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '0.75rem'
                  }}>
                    {ficheSelectionnee.fraisMission.repas?.plafond && (
                      <div style={{
                        background: '#f9fafb',
                        padding: '0.75rem',
                        borderRadius: '4px',
                        border: '1px solid #e5e7eb'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                          <Coffee size={14} style={{ color: '#059669' }} />
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Repas</span>
                        </div>
                        <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: '0.125rem 0' }}>
                          Plafond: {formatMoney(ficheSelectionnee.fraisMission.repas.plafond)} MAD/jour
                        </p>
                        <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: '0.125rem 0' }}>
                          Total estimé: {formatMoney(ficheSelectionnee.fraisMission.repas.plafond * (ficheSelectionnee.nombreJours || 0))} MAD
                        </p>
                      </div>
                    )}

                    {ficheSelectionnee.fraisMission.hotel?.plafond && (
                      <div style={{
                        background: '#f9fafb',
                        padding: '0.75rem',
                        borderRadius: '4px',
                        border: '1px solid #e5e7eb'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                          <Hotel size={14} style={{ color: '#3b82f6' }} />
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Hébergement</span>
                        </div>
                        <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: '0.125rem 0' }}>
                          Plafond: {formatMoney(ficheSelectionnee.fraisMission.hotel.plafond)} MAD/nuit
                        </p>
                        <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: '0.125rem 0' }}>
                          Total estimé: {formatMoney(ficheSelectionnee.fraisMission.hotel.plafond * (ficheSelectionnee.nombreJours || 0))} MAD
                        </p>
                      </div>
                    )}

                    {ficheSelectionnee.fraisMission.transport?.plafond && (
                      <div style={{
                        background: '#f9fafb',
                        padding: '0.75rem',
                        borderRadius: '4px',
                        border: '1px solid #e5e7eb'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                          <Car size={14} style={{ color: '#f59e0b' }} />
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Transport</span>
                        </div>
                        <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: '0.125rem 0' }}>
                          Plafond: {formatMoney(ficheSelectionnee.fraisMission.transport.plafond)} MAD
                        </p>
                      </div>
                    )}

                    {ficheSelectionnee.fraisMission.autres?.plafond && (
                      <div style={{
                        background: '#f9fafb',
                        padding: '0.75rem',
                        borderRadius: '4px',
                        border: '1px solid #e5e7eb'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                          <Building size={14} style={{ color: '#8b5cf6' }} />
                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>
                            Autres frais {ficheSelectionnee.fraisMission.autres.description ? `(${ficheSelectionnee.fraisMission.autres.description})` : ''}
                          </span>
                        </div>
                        <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: '0.125rem 0' }}>
                          Plafond: {formatMoney(ficheSelectionnee.fraisMission.autres.plafond)} MAD
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Total estimé */}
                  <div style={{
                    background: '#f0f9ff',
                    padding: '0.75rem',
                    borderRadius: '4px',
                    border: '1px solid #7dd3fc',
                    marginTop: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#0369a1' }}>
                      Total estimé des frais
                    </span>
                    <span style={{ fontSize: '1rem', fontWeight: '700', color: '#059669' }}>
                      {formatMoney(calculateTotalFrais(ficheSelectionnee))} MAD
                    </span>
                  </div>
                </div>
              )}

              {/* Avance sur frais */}
              {ficheSelectionnee.avanceSurFrais?.active && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <h4 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#374151',
                    margin: '0 0 0.75rem 0',
                    paddingBottom: '0.5rem',
                    borderBottom: '2px solid #3b82f6'
                  }}>
                    Avance sur Frais Demandée
                  </h4>
                  <div style={{
                    background: '#fef3c7',
                    padding: '0.75rem',
                    borderRadius: '4px',
                    border: '1px solid #fbbf24'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <p style={{ fontSize: '0.75rem', color: '#92400e', margin: 0 }}>Montant demandé</p>
                        <p style={{ fontSize: '1.25rem', fontWeight: '700', color: '#92400e', margin: '0.25rem 0 0 0' }}>
                          {formatMoney(ficheSelectionnee.avanceSurFrais.montant)} MAD
                        </p>
                      </div>
                      {ficheSelectionnee.avanceSurFrais.raison && (
                        <div>
                          <p style={{ fontSize: '0.75rem', color: '#92400e', margin: 0 }}>Raison</p>
                          <p style={{ fontSize: '0.875rem', color: '#92400e', margin: '0.25rem 0 0 0' }}>
                            {ficheSelectionnee.avanceSurFrais.raison}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Validation Hiérarchique */}
              {ficheSelectionnee.validationHierarchique?.decision && (
                <div style={{
                  background: '#f9fafb',
                  padding: '1rem',
                  borderRadius: '6px',
                  border: '1px solid #e5e7eb',
                  marginTop: '1.5rem'
                }}>
                  <h4 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#374151',
                    margin: '0 0 0.75rem 0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    {ficheSelectionnee.validationHierarchique.decision === 'Approuvé' ? (
                      <>
                        <CheckCircle size={16} style={{ color: '#059669' }} />
                        Fiche approuvée
                      </>
                    ) : (
                      <>
                        <XCircle size={16} style={{ color: '#dc2626' }} />
                        Fiche refusée
                      </>
                    )}
                  </h4>

                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '1rem',
                    marginBottom: '0.75rem'
                  }}>
                    {ficheSelectionnee.validationHierarchique.admin && (
                      <div>
                        <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Validé par</p>
                        <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                          {ficheSelectionnee.validationHierarchique.admin.nom || 'N/A'}
                        </p>
                      </div>
                    )}
                    {ficheSelectionnee.validationHierarchique.dateValidation && (
                      <div>
                        <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Date de validation</p>
                        <p style={{ fontSize: '0.875rem', color: '#1f2937', margin: '0.25rem 0' }}>
                          {formatDate(ficheSelectionnee.validationHierarchique.dateValidation)}
                        </p>
                      </div>
                    )}
                  </div>

                  {ficheSelectionnee.validationHierarchique.commentaire && (
                    <div>
                      <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>Commentaire</p>
                      <p style={{
                        fontSize: '0.875rem',
                        color: '#1f2937',
                        margin: '0.25rem 0',
                        fontStyle: 'italic',
                        background: 'white',
                        padding: '0.5rem',
                        borderRadius: '4px',
                        border: '1px solid #e5e7eb'
                      }}>
                        "${ficheSelectionnee.validationHierarchique.commentaire}"
                      </p>
                    </div>
                  )}
                </div>
              )}

              {/* Actions */}
              <div style={{
                display: 'flex',
                gap: '1rem',
                marginTop: '1.5rem',
                paddingTop: '1.5rem',
                borderTop: '1px solid #e5e7eb'
              }}>
                {(ficheSelectionnee.statut === 'Brouillon' || ficheSelectionnee.statut === 'Refusé') && (
                  <button
                    onClick={() => {
                      closeViewModal();
                      handleEdit(ficheSelectionnee);
                    }}
                    style={{
                      background: '#3b82f6',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '0.75rem 1.5rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      fontSize: '0.875rem',
                      fontWeight: '600'
                    }}
                  >
                    <Edit size={16} />
                    Modifier
                  </button>
                )}
                <button
                  onClick={closeViewModal}
                  style={{
                    background: 'transparent',
                    color: '#374151',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    padding: '0.75rem 1.5rem',
                    cursor: 'pointer',
                    fontSize: '0.875rem',
                    fontWeight: '600'
                  }}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default FichesMissionCommercial;